import Nullstack from 'nullstack';
export default function IconMoodBoy({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-mood-boy",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 16a3.5 3.5 0 0 0 5 0"
  }), "   ", Nullstack.element("path", {
    d: "M8.5 2c1.5 1 2.5 3.5 2.5 5"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 2c1.5 2 2 3.5 2 5"
  }), "   ", Nullstack.element("line", {
    x1: "9",
    y1: "12",
    x2: "9.01",
    y2: "12"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "12",
    x2: "15.01",
    y2: "12"
  }), " ");
}